import { ButtonBaseProps, CircularProgress, Icon, styled } from '@mui/material';
import React from 'react';

import { CheckmarkIcon } from '@ocx/ui-icons';

import { DetailsArrow } from './details-arrow.component';
import { DynamicCardAccessoryType } from './dynamic-card.types';
import { PlusButton } from './plus-button.component';
import { SizingMultiplier } from '../../sizing-multiplier.constant';

export type DynamicCardAccessoryProps = {
  type: DynamicCardAccessoryType;
  onClick?(): void;
  disabled?: boolean;
  'data-testid'?: string;
};

const AccessoryGroup = styled('div')<{ disabled?: boolean }>(({ theme, disabled }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: theme.spacing(SizingMultiplier.sm),
  opacity: disabled ? 0.5 : 1,
}));

export const DynamicCardAccessory = ({
  type,
  onClick,
  disabled,
  'data-testid': dataTestId,
}: DynamicCardAccessoryProps) => {
  const onPlusButtonClick: ButtonBaseProps['onClick'] = (e) => {
    e.stopPropagation();
    onClick?.();
  };

  switch (type) {
    case 'none':
      return null;

    case 'disclosureIndicator':
      return <DetailsArrow data-testid={dataTestId} />;

    case 'plusButton':
      return (
        <AccessoryGroup disabled={disabled} data-testid={dataTestId}>
          <PlusButton onClick={onClick} />
        </AccessoryGroup>
      );

    case 'plusButtonAndDisclosureIndicator':
      return (
        <AccessoryGroup disabled={disabled} data-testid={dataTestId}>
          <PlusButton onClick={onPlusButtonClick} />
          <DetailsArrow />
        </AccessoryGroup>
      );

    case 'checkmark':
      return (
        <Icon color="primary" data-testid={dataTestId}>
          <CheckmarkIcon sx={{ width: 16, height: 12 }} />
        </Icon>
      );

    case 'spinner': {
      const circularProgressSize = 8 * SizingMultiplier.md;
      return <CircularProgress color="primary" size={circularProgressSize} data-testid={dataTestId} />;
    }

    default:
      return null;
  }
};
